import { __exports as t } from "../../../_virtual/cardholder-name.js";
Object.defineProperty(t, "__esModule", { value: !0 });
t.cardholderName = void 0;
var i = /^[\d\s-]*$/, f = 255;
function r(e, a) {
  return { isValid: e, isPotentiallyValid: a };
}
function l(e) {
  return typeof e != "string" ? r(!1, !1) : e.length === 0 ? r(!1, !0) : e.length > f ? r(!1, !1) : i.test(e) ? r(!1, !0) : r(!0, !0);
}
t.cardholderName = l;
export {
  t as default
};
